import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { createMarkup } from 'lib/Utils'
import './index.scss'

class Service extends Component {
  constructor () {
    super()
    this.state = { someKey: 'someValue' }
  }

  render () {
    let item = this.props.item
    return (
      <article className='service'>
        <div className='service__content content' dangerouslySetInnerHTML={createMarkup(item.content.rendered)} />
      </article>
    )
  }
}

Service.propTypes = {
  item: PropTypes.object
}

export default Service



// WEBPACK FOOTER //
// ./src/components/Service/index.js